// Where a buyer's phone number shows. Mirrors PHONE_MODES in backend/global_funnels.py.
export const PHONE_OPTIONS = [
  ["both", "On landing pages and thank-you pages"],
  ["thank_you", "Only on thank-you pages"],
  ["landers", "Only on landing pages"],
  ["none", "Nowhere (number stays saved)"],
];

export const phoneModeOf = (page) => page?.phone_display || (page?.hide_phone_display ? "none" : "both");

// True when `mode` hides the phone on `where` ("landers" or "thank_you").
export const hidesPhone = (mode, where) => mode === "none" || mode === (where === "landers" ? "thank_you" : "landers");

export function PhoneDisplaySelect({ value, onChange, testId }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
            className="mt-1 w-full border-2 border-black bg-white px-2 py-1.5 text-sm">
      {PHONE_OPTIONS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
    </select>
  );
}
